import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

export interface WorkflowModalProps {
  open: boolean;
  title: React.ReactNode;
  icon?: string;
  onClose: () => void;
  footer?: React.ReactNode;
  children: React.ReactNode;
  wide?: boolean;
  xwide?: boolean;
}

/** Minimal portal modal for the workflow flows (dry-run plan, rollback, agent configurator). */
const WorkflowModal: React.FC<WorkflowModalProps> = ({ open, title, icon, onClose, footer, children, wide, xwide }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div className="cwf-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()} role="presentation">
      <div className={`cwf-modal ${wide ? 'cwf-modal--wide' : ''} ${xwide ? 'cwf-modal--xwide' : ''}`} role="dialog" aria-modal="true">
        <header className="cwf-modal__head">
          <h3>
            {icon ? <i className={`fas ${icon}`} aria-hidden="true" /> : null}
            {title}
          </h3>
          <button type="button" className="cwf-modal__close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>
        <div className="cwf-modal__body">{children}</div>
        {footer ? <footer className="cwf-modal__foot">{footer}</footer> : null}
      </div>
    </div>,
    document.body
  );
};

export default WorkflowModal;
